import gsap from 'gsap';

import App from '../../app';

export default class Overlay {

	static selector = 'slider-team-overlay';

	el = {};

	activeIndex = 0;

	constructor(container, slides) {
		this.el = {
			container,
			slides,
			items: container.querySelectorAll(`.${this.constructor.selector}__item`),
			close: container.querySelector(`.${this.constructor.selector}__close`),
			prev: container.querySelector(`.${this.constructor.selector}__prev`),
			next: container.querySelector(`.${this.constructor.selector}__next`),
		};

		this.triggers = [];

		for (const slide of this.el.slides) {
			this.triggers.push(slide.querySelector('.slider-team__overlay-trigger'));
		}

		this.addEventListeners();
	}

	addEventListeners() {
		for (const trigger of this.triggers) {
			trigger.addEventListener('click', this.#onTriggerClick);
		}

		this.el.prev.addEventListener('click', this.#onPrevClick);
		this.el.next.addEventListener('click', this.#onNextClick);
		this.el.close.addEventListener('click', this.#onCloseClick);
	}

	removeEventListeners() {
		for (const trigger of this.triggers) {
			trigger.removeEventListener('click', this.#onTriggerClick);
		}

		this.el.prev.removeEventListener('click', this.#onPrevClick);
		this.el.next.removeEventListener('click', this.#onNextClick);
		this.el.close.removeEventListener('click', this.#onCloseClick);
	}

	showOverlaySlide() {
		gsap.fromTo(this.el.items[this.activeIndex], {
			autoAlpha: 0
		}, {
			ease: 'power2.out',
			autoAlpha: 1,
			duration: 0.5
		});
	}

	hideOverlaySlide() {
		gsap.fromTo(this.el.items[this.activeIndex], {
			autoAlpha: 1
		}, {
			ease: 'power2.out',
			autoAlpha: 0,
			duration: 0.5
		});
	}

	#onPrevClick = () => {
		this.el.items[this.activeIndex].classList.remove('is-active');
		this.hideOverlaySlide();

		this.activeIndex -= 1;

		if (this.activeIndex < 0) {
			this.activeIndex = this.el.items.length - 1;
		}

		this.el.items[this.activeIndex].classList.add('is-active');
		this.showOverlaySlide();
	}

	#onNextClick = () => {
		this.el.items[this.activeIndex].classList.remove('is-active');
		this.hideOverlaySlide();

		this.activeIndex += 1;

		if (this.activeIndex > this.el.items.length - 1) {
			this.activeIndex = 0;
		}

		this.el.items[this.activeIndex].classList.add('is-active');
		this.showOverlaySlide();
	}

	#onTriggerClick = (e) => {
		this.el.items[this.activeIndex].classList.remove('is-active');

		const index = parseInt(e.currentTarget.dataset.overlayIndex);
		this.activeIndex = index;
		this.el.items[this.activeIndex].classList.add('is-active');

		App.freeze();
		App.dim();

		this.timelineShow = gsap.timeline({
			onComplete: () => {
				this.timelineShow.kill();
				this.timelineShow = null;
			}
		});
		this.timelineShow
			.set(this.el.container, {
				display: 'block'
			})
			.fromTo(this.el.container, {
				autoAlpha: 0,
				x: 150
			}, {
				ease: 'expo.inOut',
				autoAlpha: 1,
				x: 0,
				duration: 1
			});

		this.showOverlaySlide();
	}

	#onCloseClick = () => {
		App.thaw();
		App.undim();

		this.timelineClose = gsap.timeline({
			onComplete: () => {
				this.timelineClose.kill();
				this.timelineClose = null;
			}
		});
		this.timelineClose
			.fromTo(this.el.container, {
				autoAlpha: 1,
			}, {
				ease: 'expo.out',
				autoAlpha: 0,
				duration: 0.35
			}, 'start')
			.set(this.el.items[this.activeIndex], {
				autoAlpha: 0
			}, 'end')
			.set(this.el.container, {
				display: 'none'
			}, 'end');
	}

	destroy() {
		this.removeEventListeners();
	}

}
